<template>
  <div class="requirements-candidate relative">
    <div
      v-if="!vacancyCreated"
      class="card-disable-cover _white"
      @click="$emit('click:disable-cover', $event)"
    ></div>

    <div class="requirements-candidate__section edit-group" data-edit-group="9">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('person_types') }}
        </h4>
      </div>
      <ButtonCheckList ref="input-person_types"
                       :value="inputs.person_types.value"
                       :options="personTypes"
                       compareType="id"
                       text-key="name"
                       @input="onPersonTypesInput"
                       class="edit-group__row _blue"/>
    </div>
    <!--    <div class="requirements-candidate__section edit-group" data-edit-group="5">-->
    <!--      <div class="edit-group__head _blue">-->
    <!--        <h4 class="edit-group__title">-->
    <!--          {{ $tNewVacancy2('documents_for_start') }}-->
    <!--        </h4>-->
    <!--      </div>-->
    <!--      <ButtonCheckList :value="inputs.documents_for_start.value"-->
    <!--                       :options="documentsForStartComputed"-->
    <!--                       compareType="id"-->
    <!--                       text-key="name"-->
    <!--                       @input="documentsForStartInput"-->
    <!--                       class="edit-group__row _blue"/>-->
    <!--      <TranslateFiled v-if="documentsForStartOtherOpen"-->
    <!--                      :label="$tNewVacancy2('Name documents')"-->
    <!--                      :value="inputs.documents_for_start_other.value"-->
    <!--                      @input="changeAction('documents_for_start_other', 'setInputValue', ['documents_for_start_other', $event])"-->
    <!--                      @blur="saveAction('documents_for_start_other', ['documents_for_start_other', $event])"-->
    <!--                      class="requirements-candidate__translate-field"-->
    <!--      />-->
    <!--    </div>-->

    <!--    <div class="requirements-candidate__section edit-group">-->
    <!--      <div class="edit-group__head _blue">-->
    <!--        <h4 class="edit-group__title">-->
    <!--          {{ $tNewVacancy2('location_priority') }}-->
    <!--        </h4>-->
    <!--      </div>-->
    <!--      <ButtonCheckList :value="inputs.location_priority.value"-->
    <!--                       :options="locationsPriority"-->
    <!--                       type="radio"-->
    <!--                       compareType="id"-->
    <!--                       text-key="name"-->
    <!--                       @input="changeAction('location_priority', 'setInputValue', ['location_priority', $event])"-->
    <!--                       class="edit-group__row _blue"/>-->
    <!--    </div>-->
    <div v-if="!inputs.employment_types.disabled" class="requirements-candidate__section edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('employment_types') }}
        </h4>
      </div>
      <ButtonCheckList ref="input-employment_types"
                       :value="inputs.employment_types.value"
                       :options="employmentTypes"
                       compareType="id"
                       text-key="name"
                       @input="changeAction('employment_types', 'setInputValue', ['employment_types', $event])"
                       class="edit-group__row _blue"/>
    </div>
    <div class="requirements-candidate__section edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('experience_requirement') }}
        </h4>
      </div>
      <ButtonCheckList
        ref="input-experience_requirement"
        :value="inputs.experience_requirement.value"
        :options="experienceRequirement"
        type="radio"
        compareType="id"
        text-key="name"
        @input="changeAction('experience_requirement', 'setInputValue', ['experience_requirement', $event])"
        class="edit-group__row _blue"/>
    </div>
    <div ref="input-age_range" class="requirements-candidate__section edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('age_range') }}
        </h4>
      </div>
      <ButtonCheckList ref="input-any_age"
                       :value="inputs.any_age.value"
                       :options="ageTypes"
                       type="radio"
                       compareType="id"
                       text-key="name"
                       @input="onAgeTypeInput"
                       class="edit-group__row _blue"/>
      <SliderRange v-if="inputs.any_age.value && inputs.any_age.value.id === false"
                   :value="inputs.age_range.value"
                   :min="ageMin"
                   :max="ageMax"
                   @input="changeAction('age_range', 'setInputValue', ['age_range', $event])"
                   :interval="1"

      />
    </div>
    <div ref="input-languages" class="requirements-candidate__section edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('Language Requirements') }}
        </h4>
      </div>
      <ButtonCheckList ref="input-without_language"
                       :value="inputs.without_language.value"
                       :options="yesOrNoWithNoSpecify"
                       type="radio"
                       compareType="id"
                       text-key="name"
                       @input="onWithoutLanguageChange"
                       class="edit-group__row _blue"/>
      <div v-if="inputs.without_language.value && inputs.without_language.value.id"
           class="multiple">
        <div v-for="(language, index) in inputs.languages"
             :key="language._id"
             class="multiple__item">
          <button v-if="inputs.languages.length > 1"
                  @click.prevent="changeAction('languages', 'deleteLanguage', index)"
                  class="multiple__delete  reset-button">
            <BaseSvg name="ico-trash"/>
          </button>
          <SLanguage :label="$tNewVacancy2('Choose language')"
                     :value="language.language.value"
                     :list-filter="languagesListFilter"
                     :placeholder="$tNewVacancy2('placeholder_choose_language')"
                     @input="onLanguageInput(['languages', index, 'language', $event])"
                     class="edit-group__row  _white"/>
          <ButtonCheckList v-if="language.language.value"
                           :value="language.level.value"
                           compareType="id"
                           text-key="name"
                           :options="languageLevel"
                           @input="changeAction('languages', 'setArrayInputValue', ['languages', index, 'level', $event])"
                           class="_blue _three-columns"/>
        </div>
        <!--      <BaseInputError :value="inputs.any_profession.error"/>-->
        <button @click.prevent="addLanguage"
                class="multiple__add  base-btn  base-btn--outline-dark  base-btn--small">
          <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem"/>
          <span>
            {{ $tNewVacancy2('Add language') }}
          </span>
        </button>
      </div>
    </div>
    <div class="requirements-candidate__section  edit-group" data-edit-group="6">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('physical_activity') }}
        </h4>
      </div>
      <ButtonCheckList ref="input-physical_activity"
                       :value="inputs.physical_activity.value"
                       :options="physicalActivities"
                       type="radio"
                       compareType="id"
                       text-key="name"
                       @input="changeAction('physical_activity', 'setInputValue', ['physical_activity', $event])"
                       class="edit-group__row  _blue  _three-columns"/>

      <TranslateFiled ref="input-physical_activity_description"
                      :value="inputs.physical_activity_description.value"
                      :label="$tNewVacancy2('Description')"
                      :placeholder="$tNewVacancy2('specify_physical_activity_description')"
                      editor
                      :disabled="inputs.physical_activity_description.disabled"
                      :disable-toggle-text="$tNewVacancy2('Specify a description')"
                      :use-editor-headings="useEditorsHeadings"
                      :use-translate-buttons="useFieldsTranslations"
                      :original-locale="originalLocale"
                      @input="changeAction('physical_activity_description', 'setInputValue', ['physical_activity_description', $event])"
                      @blur="saveAction('physical_activity_description', ['physical_activity_description', $event])"
                      @update:disabled="toggleDisabled('physical_activity_description', $event)"
      />
    </div>
    <div class="requirements-candidate__section  edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('acceptable_disability') }}
        </h4>
      </div>
      <ButtonCheckList
        ref="input-acceptable_disability"
        :value="inputs.acceptable_disability.value"
        :options="yesOrNoWithNoSpecify"
        type="radio"
        compareType="id"
        text-key="name"
        @input="onAcceptableDisabilityInput"
        class="edit-group__row _blue"/>

      <TranslateFiled v-if="inputs.acceptable_disability.value && inputs.acceptable_disability.value.id"
                      :value="inputs.acceptable_disability_description.value"
                      :label="$tNewVacancy2('Description')"
                      :use-translate-buttons="useFieldsTranslations"
                      :use-editor-headings="useEditorsHeadings"
                      :original-locale="originalLocale"
                      editor
                      @input="changeAction('acceptable_disability_description', 'setInputValue', ['acceptable_disability_description', $event])"
                      @blur="saveAction('acceptable_disability_description', ['acceptable_disability_description', $event])"
      />
    </div>
    <div class="requirements-candidate__section  edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('education') }}
        </h4>
      </div>
      <ButtonCheckList ref="input-education"
                       :value="educationLevel"
                       :options="educationLevelsComputed"
                       type="radio"
                       compareType="id"
                       text-key="name"
                       @input="onEducationLevelsInput"
                       class="edit-group__row _blue"/>
      <TranslateFiled ref="input-education_description"
                      v-if="!notActive"
                      :value="inputs.education_description.value"
                      class="_edit-not-active"
                      :label="$tNewVacancy2('Description')"
                      :use-translate-buttons="useFieldsTranslations"
                      :use-editor-headings="useEditorsHeadings"
                      :original-locale="originalLocale"
                      editor
                      @input="changeAction('education_description', 'setInputValue', ['education_description', $event])"
                      @blur="saveAction('education_description', ['education_description', $event])"
      />
    </div>
    <div class="requirements-candidate__section _lang edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('Additional requirements') }}
        </h4>
      </div>
      <TranslateFiled ref="input-additional_requirements"
                      :value="inputs.additional_requirements.value"
                      :label="$tNewVacancy2('Specify special requirements')"
                      :disabled="inputs.additional_requirements.disabled"
                      :disable-toggle-text="$tNewVacancy2('Specify a description')"
                      :use-translate-buttons="useFieldsTranslations"
                      :use-editor-headings="useEditorsHeadings"
                      :original-locale="originalLocale"
                      editor
                      @input="changeAction('additional_requirements', 'setInputValue', ['additional_requirements', $event])"
                      @blur="saveAction('additional_requirements', ['additional_requirements', $event])"
                      @update:disabled="toggleDisabled('additional_requirements', $event)"
      />
    </div>

    <div class="requirements-candidate__section _additional-documents edit-group">
      <div class="edit-group__head _blue">
        <h4 class="edit-group__title">
          {{ $tNewVacancy2('additional documents') }}
        </h4>
      </div>
      <div key="comment"
           class="edit-group__row">
        <TranslateFiled ref="input-additional_required_documents_comment"
                        :value="inputs.additional_required_documents_comment.value"
                        :label="$tNewVacancy2('comment')"
                        :disabled="inputs.additional_required_documents_comment.disabled"
                        :disable-toggle-text="$tNewVacancy2('specify_comment')"
                        :use-translate-buttons="useFieldsTranslations"
                        :use-editor-headings="useEditorsHeadings"
                        :original-locale="originalLocale"
                        style="width: 100%;"
                        editor
                        :placeholder="$tNewVacancy2('placeholder_required_documents_comment')"
                        @input="changeAction('additional_required_documents_comment', 'setInputValue', ['additional_required_documents_comment', $event])"
                        @blur="saveAction('additional_required_documents_comment', ['additional_required_documents_comment', $event])"
                        @update:disabled="toggleDisabled('additional_required_documents_comment', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import ButtonCheckList from '../ButtonCheckList'
  import TranslateFiled from '../TranslateFiled'
  import SliderRange from '../SliderRange'
  import SLanguage from '../loadingSelects/SLanguage'

  let timer


  export default {
    name: "EditRequirementsCandidate",
    components: {
      ButtonCheckList,
      TranslateFiled,
      SliderRange,
      SLanguage,
    },
    props: {
      vacancyCreated: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      notActive: true, // hide
    }),
    computed: {
      ...mapState('vacancyEdit', {
        'ageMin': 'ageMin',
        'ageMax': 'ageMax',
        'personTypes': 'personTypes',
        'documentsForStart': 'documentsForStart',
        'experienceRequirement'(state) {
          return this.addNoSpecifyItemForList(state.experienceRequirement)
        },
        'languageLevel': 'languageLevel',
        'physicalActivities'(state) {
          return this.addNoSpecifyItemForList(state.physicalActivities)
        },
        'educationLevels': 'educationLevels',
        'additionalDocuments': 'additionalDocuments',
        'employmentTypes': 'employmentTypes',
        'locationsPriority': 'locationsPriority',

      }),
      ...mapGetters('vacancyEdit', [
        'otherDocuments',
        'ageTypes',
        'yesOrNo',
        'afterJustCreated',
        'savedBlocks',
        'originalLocale',
      ]),
      ...mapGetters('user', [
        'isOur',
        'employerProfile',
      ]),
      ...mapState('vacancyEdit/sectionRequirements', [
        'inputs',
      ]),
      useFieldsTranslations() {
        return this.isOur && this.savedBlocks?.[1] === true && !this.afterJustCreated;
      },
      defaultChekListValue() {
        return {
          id: null,
          name: this.$tNewVacancy2('No specified')
        }
      },
      yesOrNoWithNoSpecify() {
        return this.addNoSpecifyItemForList(this.yesOrNo)
      },
      documentsForStartComputed() {
        return [...(this.documentsForStart || []), this.otherDocuments]
      },
      documentsForStartOtherOpen() {
        return this.inputs.documents_for_start.value
          && this.inputs.documents_for_start.value.some(item => item.id === 'other')
      },

      educationLevelsComputed() {
        const unusedIds = [29, 30, 32];
        const levels = (this.educationLevels || []).filter(l => !unusedIds.includes(l.id));

        return [{
          id: null,
          name: this.$tNewVacancy2('Possible without education')
        }, ...levels]
      },
      educationLevel() {
        return this.inputs.education.value || {
          id: null,
          name: this.$tNewVacancy2('Possible without education')
        }
      },
      disabledFields() {
        return {
          employment_types: this.employerProfile?.country.id !== 165,
        };
      },
      useEditorsHeadings() {
        return false;
      },
    },
    beforeMount() {
      this.applyDefaultValues();

      this.saveSection()
        .then(() => this.applyDefaultDisabled());
    },
    methods: {
      ...mapMutations('vacancyEdit/sectionRequirements', [
        'setInputValue',
        'setInputDisabled',
        'setArrayInputValue',
        'addLanguage',
        'deleteLanguage',
        'deleteAllLanguages',
        'setDefaultInputsValues',
        'setDefaultInputsDisabled',
      ]),
      saveSection() {
        return this.$store.dispatch('vacancyEdit/saveSection', { sectionName: 'sectionRequirements' });
      },
      applyDefaultValues() {
        const entries = [
          ['experience_requirement', this.defaultChekListValue],
          ['without_language', this.defaultChekListValue],
          ['physical_activity', this.defaultChekListValue],
          ['acceptable_disability', this.defaultChekListValue],
        ];
        this.setDefaultInputsValues(entries);
      },
      applyDefaultDisabled() {
        const entries = Object.entries(this.disabledFields);
        const keys = ['physical_activity_description', 'additional_requirements', 'additional_required_documents_comment'];

        this.setDefaultInputsDisabled(entries);
        this.setDefaultInputsDisabled(keys);
      },
      saveAction(key, value) {
        let val;
        if (value) {
          let values = value['1'].replace(/["'{}]/g, '').replace(/,/g, ', ') || 'empty'
          val = `from ${values}`
        }
        if (val !== undefined) {
          let str = `Vacancy, Requirements for candidate. Field: ${key}, value: ${val}`
          this.$store.dispatch('sendAlert', {
            type: 'form',
            title: str
          })
        }
      },
      changeAction(key, method, value) {
        if (method) {
          this[method](value)
        }

        let val;
        if (value && value instanceof Object) {
          if (key === 'age_range') {
            if (value['1'] instanceof Array) {
              val = `from ${value['1'][0]} to ${value['1'][1]}`
            }
          } else if (key === 'languages') {
            if (value['3'] instanceof Array && value['3'] !== null) {
              let values = value['3'].map((v) => {
                return v.name
              }).toString()
              val = `${value['2']}: ${values}`
            } else if (value['3']) {
              val = `${value['2']}: ${value['3'].name}`
            }
          } else if (value['1'] !== null && value['1'].name) {
            val = value['1'].name
          } else if (value['1'] !== null && value['1'] instanceof Array) {
            val = value['1'].map((v) => {
              return v.name
            }).toString() || 'empty'
          }
        }

        clearTimeout(timer)
        timer = setTimeout(() => {
          this.saveSection();

          if (val !== undefined) {
            let str = `Vacancy, Requirements for candidate. Field: ${key}, value: ${val}`
            this.$store.dispatch('sendAlert', {
              type: 'form',
              title: str
            })
          }
        }, 1000)

      },
      toggleDisabled(key, value) {
        this.setInputDisabled([key, !value]);
      },

      languagesListFilter(item) {
        return !this.inputs.languages.find(l => l.language.value?.id === item.id);
      },
      onWithoutLanguageChange(value) {
        if (!value.id) {
          this.deleteAllLanguages()
        } else if (!this.inputs.languages.length) {
          this.addLanguage();
        }
        this.changeAction('without_language', 'setInputValue', ['without_language', value])
      },

      onPersonTypesInput(value) {
        const haveAll = this.inputs.person_types.value && this.inputs.person_types.value.find(item => item?.need_action)
        const haveValueAll = value && value.find(item => item?.need_action)

        if (!haveAll && haveValueAll) {
          value = [...this.personTypes]
        } else if (haveValueAll && haveAll) {
          value = value.filter(item => !item?.need_action)
        }

        this.changeAction('person_types', 'setInputValue', ['person_types', value])
      },

      documentsForStartInput(value) {
        const hasOtherValue = !!this.inputs.documents_for_start_other.value
        const hasOther = value.some(item => item.id === 'other')

        if (!hasOther && hasOtherValue) {
          this.changeAction('documents_for_start_other', 'setInputValue', ['documents_for_start_other', null])
        }

        this.changeAction('documents_for_start', 'setInputValue', ['documents_for_start', value])
      },
      onAgeTypeInput(value) {
        if (value.id === true) {
          this.setInputValue(['age_range', null])
        } else if (value.id === false) {
          this.setInputValue(['age_range', [this.ageMin, this.ageMax]])
        }

        this.setInputValue(['any_age', value])
        this.changeAction('age_range')
      },
      onAcceptableDisabilityInput(value) {
        if (!value.id) {
          this.setInputValue(['acceptable_disability_description', null])
        }
        this.changeAction('acceptable_disability', 'setInputValue', ['acceptable_disability', value])
      },

      onEducationLevelsInput(value) {
        this.changeAction('education', 'setInputValue', ['education', value && value.id ? value : null])
      },

      onLanguageInput(value) {
        if (!value[3]) {
          this.setArrayInputValue(['languages', value[1], 'level', null])
        }
        this.changeAction('languages', 'setArrayInputValue', value)
      },
      addNoSpecifyItemForList(list) {
        return [this.defaultChekListValue, ...(list || [])]
      }
    },
  }
</script>

<style scoped>

</style>
